module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QoRBSQP1EV0AAAAAOhJREFUSMft1LFKA0EURuFvN2mSJlpYKBa+hZWlTyHYKNppKfgIFkkbxORdIhaptLNIbZ1eMKzNRdYQV5EMpJgDFxZ2Zs/sZf5LJpPZWAZXZ2U8tjFC1VDvuEDx23fbP72oiq+9Fd7wisXSsgUOsIUjjPGxjh/uYnupejjEPCQnqbu+j1l04Ca1bA/TkN2hTCnbxXPIHtBJKevgPmQv2EkpK9EP2TTampTbkM3iwqyX/vV5PcSnkbl5RKG3Iibdv7ZpJQWt2nA4jrUFhnjEpFZPEY3W4PtB/0WByxhfTeNt1DS5MpnM5vAJyY03ifAUIEgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/1.png
// module id = zFeK
// module chunks = 0